var map = {
	"./competitions-light.png": 2372,
	"./consilium-login-logo-light.png": 8541,
	"./edit-light.png": 580,
	"./entities-light.png": 353,
	"./login-bg-light.png": 7601,
	"./organizations-light.png": 7636,
	"./results-light.png": 8282,
	"./roles-light.png": 1675,
	"./settings-light.png": 519,
	"./templates-light.png": 6049,
	"./trainings-light.png": 3165,
	"./trash-light.png": 3694,
	"./users-light.png": 2960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7429;